import { ResourceExport } from '../../types/resource-export.type';
import ScreenList from './ScreenList';
import ScreenIcon from '@material-ui/icons/Tv';

const Screen: ResourceExport = {
  list: ScreenList,
  icon: ScreenIcon,
};
export default Screen;
